"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M17.1611 11.9404L17.9701 14.6694C18.1261 15.2534 17.6601 15.8214 17.0181 15.8284H17.0171C16.3671 15.8354 15.8861 15.2624 16.0441 14.6694L16.8481 11.9404C16.8981 11.7914 17.1091 11.7914 17.1611 11.9404ZM6.34665 10.6543L7.70665 9.2933C7.89465 9.1053 8.14965 9.0003 8.41365 9.0003H11.3987C11.6196 9.0003 11.7326 9.2683 11.5757 9.4263L8.32465 12.6893C8.12965 12.8843 7.81465 12.8823 7.62265 12.6833L6.33965 11.3543C6.15065 11.1583 6.15365 10.8463 6.34665 10.6543ZM10.1768 2C10.1138 2 10.0487 2.024 9.99975 2.073L2.58575 9.414C1.80475 10.195 1.80475 11.462 2.58575 12.242L6.75775 16.414C7.14775 16.805 7.65975 17 8.17175 17C8.68375 17 9.19575 16.805 9.58575 16.414L16.9948 9.005C17.0927 8.907 17.0927 8.749 16.9948 8.651L10.3538 2.073C10.3048 2.024 10.2408 2 10.1768 2ZM10.1768 4.713L14.3368 8.834L8.52475 14.647C8.32875 14.842 8.01375 14.843 7.81875 14.647L4.34975 11.19C4.15375 10.995 4.15375 10.677 4.35075 10.481L10.1768 4.713Z",
    fill: "#727B7F"
  }));
};